import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, mergeProps as _mergeProps, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock } from "vue";

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 查询 ");

import { ref, computed, watch } from 'vue';
import { getBindCusInfoList } from '@/request';
import { getVexTableProps } from '@/config';
export default {
  name: 'BindCustomerInfoModal',
  props: {
    modelValue: {
      type: Boolean,
      default: false
    },
    supUserId: {
      type: [String, Number],
      default: ''
    }
  },
  emits: ['update:modelValue'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const visible = computed({
      get() {
        return props.modelValue;
      },

      set(val) {
        emit('update:modelValue', val);
      }

    });
    const code = ref('');
    const table = ref();
    watch(() => props.modelValue, () => {
      var _table$value;

      (_table$value = table.value) === null || _table$value === void 0 ? void 0 : _table$value.commitProxy('reload');
    });
    const tableOptions = getVexTableProps({
      columns: [{
        type: 'seq',
        width: '50px',
        fixed: 'left'
      }, {
        title: '客户编码',
        field: 'danwBh',
        width: '200px',
        showOverflow: true
      }, {
        title: '客户名称',
        field: 'custName',
        width: '150px',
        showOverflow: true
      }, {
        title: '客户类型',
        field: 'custTypeName',
        width: '150px',
        showOverflow: true
      }, {
        title: '客户区域',
        field: 'territories',
        showOverflow: true
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => new Promise(res => {
            getBindCusInfoList({
              page: page.currentPage,
              rows: page.pageSize,
              keyWord: code.value,
              supUserId: props.supUserId
            }).then(data => {
              res({
                total: data.total,
                result: data.rows
              });
            });
          })
        }
      }
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");

      const _component_el_col = _resolveComponent("el-col");

      const _component_el_button = _resolveComponent("el-button");

      const _component_el_row = _resolveComponent("el-row");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      const _component_el_dialog = _resolveComponent("el-dialog");

      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "绑定客户明细",
        modelValue: _unref(visible),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(visible) ? visible.value = $event : null),
        width: "800px"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_row, {
          gutter: 20
        }, {
          default: _withCtx(() => [_createVNode(_component_el_col, {
            span: 6
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: code.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => code.value = $event),
              placeholder: "请输入名称"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_col, {
            span: 2
          }, {
            default: _withCtx(() => [_createVNode(_component_el_button, {
              type: "primary",
              icon: "Search",
              onClick: _cache[1] || (_cache[1] = $event => table.value.commitProxy('reload'))
            }, {
              default: _withCtx(() => [_hoisted_1]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_vxe_grid, _mergeProps(_unref(tableOptions), {
          ref_key: "table",
          ref: table
        }), null, 16)]),
        _: 1
      }, 8, ["modelValue"]);
    };
  }

};